var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tui-chat",
    class: [_vm.isH5 ? 'tui-chat-h5' : '']
  }, [_c('div', {
    staticClass: "tui-chat-main",
    attrs: {
      "id": "tui-chat-main"
    },
    on: {
      "click": _vm.closeChatPop
    }
  }, [_c('ul', {
    ref: "messageListRef",
    staticClass: "tui-message-list",
    attrs: {
      "id": "messageScrollList"
    },
    on: {
      "click": _vm.onMessageListBackgroundClick
    }
  }, [!_vm.isCompleted && _vm.messageList && _vm.messageList.length ? _c('li', {
    staticClass: "message-more",
    on: {
      "click": _vm.getHistoryMessageList
    }
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("TUIChat.查看更多")) + " ")]) : _vm._e(), _vm._l(_vm.messageList, function (item, index) {
    return _c('li', {
      key: item.ID,
      ref: "messageElementListRef",
      refInFor: true,
      staticClass: "message-li",
      attrs: {
        "id": 'tui-' + item.ID
      }
    }, [_c('MessageTimestamp', {
      attrs: {
        "currTime": item.time,
        "prevTime": index > 0 ? _vm.messageList[index - 1].time : 0
      }
    }), _c('div', {
      staticClass: "message-item"
    }, [item.isRevoked ? _c('MessageRevoked', {
      attrs: {
        "isEdit": item.type === _vm.TYPES.MSG_TEXT,
        "messageItem": item
      },
      on: {
        "messageEdit": function ($event) {
          return _vm.handleEdit(item);
        }
      }
    }) : _vm.isPluginMessage(item) ? _c('MessagePlugin', {
      attrs: {
        "message": _vm.deepCopy(item),
        "blinkMessageIDList": _vm.blinkMessageIDList,
        "enableFeedback": _vm.props.enableFeedback,
        "enableAINote": _vm.props.enableAINote
      },
      on: {
        "resendMessage": _vm.resendMessage,
        "handleToggleMessageItem": _vm.handleToggleMessageItem,
        "handleH5LongPress": _vm.handleH5LongPress,
        "heightChanged": _vm.onHeightChanged,
        "messageSent": _vm.onMessageSent,
        "like": _vm.onLike,
        "dislike": _vm.onDislike,
        "previewImage": _vm.handleImagePreviewByUrl
      }
    }) : _c('div', {
      class: {
        'message-event-bind-div': true
      },
      on: {
        "longpress": function ($event) {
          return _vm.handleToggleMessageItem($event, item, true);
        },
        "contextmenu": function ($event) {
          $event.preventDefault();
          return _vm.handleToggleMessageItemForPC($event, item);
        },
        "touchstart": function ($event) {
          return _vm.handleH5LongPress($event, item, 'touchstart');
        },
        "touchend": function ($event) {
          return _vm.handleH5LongPress($event, item, 'touchend');
        },
        "mouseover": function ($event) {
          return _vm.handleH5LongPress($event, item, 'touchend');
        }
      }
    }, [_c('MessageBubble', {
      attrs: {
        "content": item.getMessageContent(),
        "isAudioPlayed": Boolean(_vm.audioPlayedMapping[item.ID]),
        "blinkMessageIDList": _vm.blinkMessageIDList,
        "messageItem": JSON.parse(JSON.stringify(item)),
        "enableFeedback": _vm.props.enableFeedback,
        "enableAINote": _vm.props.enableAINote,
        "fileMediaType": _vm.getFileMediaType(item)
      },
      on: {
        "blinkMessage": _vm.blinkMessage,
        "resendMessage": function ($event) {
          return _vm.resendMessage(item);
        },
        "like": _vm.onLike,
        "dislike": _vm.onDislike
      },
      scopedSlots: _vm._u([{
        key: "messageElement",
        fn: function () {
          return [_vm.isThinkingMessage(item) ? _c('MessageThinking') : item.type === _vm.TYPES.MSG_TEXT ? _c('MessageText', {
            attrs: {
              "content": item.getMessageContent(),
              "flow": item.flow
            }
          }) : item.type === _vm.TYPES.MSG_IMAGE || item.type === _vm.TYPES.MSG_FILE && _vm.getFileMediaType(item) === 'image' ? _c('ProgressMessage', {
            attrs: {
              "content": _vm.getDisplayImageContent(item),
              "messageItem": item
            }
          }, [_c('MessageImage', {
            attrs: {
              "content": _vm.getDisplayImageContent(item),
              "messageItem": item
            },
            on: {
              "previewImage": function ($event) {
                var _item$getMessageConte;
                item.type === _vm.TYPES.MSG_IMAGE ? _vm.handleImagePreview(item) : _vm.handleImagePreviewByUrl((_item$getMessageConte = item.getMessageContent()) === null || _item$getMessageConte === void 0 ? void 0 : _item$getMessageConte.url);
              }
            }
          })], 1) : item.type === _vm.TYPES.MSG_VIDEO || item.type === _vm.TYPES.MSG_FILE && _vm.getFileMediaType(item) === 'video' ? _c('ProgressMessage', {
            attrs: {
              "content": _vm.getDisplayVideoContent(item),
              "messageItem": item
            }
          }, [_c('MessageVideo', {
            attrs: {
              "content": _vm.getDisplayVideoContent(item),
              "messageItem": item
            }
          })], 1) : item.type === _vm.TYPES.MSG_AUDIO ? _c('MessageAudio', {
            attrs: {
              "content": item.getMessageContent(),
              "messageItem": item
            },
            on: {
              "setAudioPlayed": _vm.setAudioPlayed
            }
          }) : item.type === _vm.TYPES.MSG_FILE ? _c('ProgressMessage', {
            attrs: {
              "content": item.getMessageContent(),
              "messageItem": item
            }
          }, [_c('MessageFile', {
            attrs: {
              "content": item.getMessageContent(),
              "messageItem": item
            }
          })], 1) : item.type === _vm.TYPES.MSG_MERGER ? _c('MessageRecord', {
            attrs: {
              "renderData": item.payload,
              "messageItem": item
            }
          }) : item.type === _vm.TYPES.MSG_FACE ? _c('MessageFace', {
            attrs: {
              "content": item.getMessageContent()
            }
          }) : item.type === _vm.TYPES.MSG_LOCATION ? _c('MessageLocation', {
            attrs: {
              "content": item.getMessageContent()
            }
          }) : item.type === _vm.TYPES.MSG_CUSTOM ? _c('MessageCustom', {
            attrs: {
              "content": item.getMessageContent(),
              "messageItem": item
            }
          }) : item.type === _vm.TYPES.MSG_STREAM ? _c('MessageLargeStream', {
            attrs: {
              "content": _vm.shallowCopyMessage(item.payload)
            },
            on: {
              "heightChanged": _vm.onHeightChanged,
              "previewImage": _vm.handleImagePreviewByUrl
            }
          }) : _vm._e()];
        },
        proxy: true
      }], null, true)
    })], 1), item.ID === _vm.toggleID ? _c('MessageTool', {
      ref: "messageToolListRef",
      refInFor: true,
      class: {
        'message-tool': true,
        'message-tool-out': item.flow === 'out',
        'message-tool-in': item.flow === 'in',
        'message-tool-bottom': _vm.isTopMessageDom
      },
      attrs: {
        "messageItem": item
      }
    }) : _vm._e()], 1)], 1);
  })], 2), _c('ScrollButton', {
    ref: "scrollButtonInstanceRef",
    on: {
      "scrollToLatestMessage": _vm.scrollToLatestMessage,
      "scrollNearToBottom": _vm.scrollNearToBottom
    }
  }), _vm.reSendDialogShow ? _c('Dialog', {
    staticClass: "resend-dialog",
    attrs: {
      "show": _vm.reSendDialogShow,
      "isH5": !_vm.isPC,
      "center": true,
      "isHeaderShow": _vm.isPC
    },
    on: {
      "submit": function ($event) {
        return _vm.resendMessageConfirm();
      },
      "update:show": function (e) {
        return _vm.reSendDialogShow = e;
      }
    }
  }, [_c('p', {
    staticClass: "delDialog-title"
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("TUIChat.确认重发该消息？")) + " ")])]) : _vm._e(), _vm.showImagePreview ? _c('ImagePreviewer', {
    attrs: {
      "currentImage": _vm.currentImagePreview,
      "imageList": _vm.imageMessageList,
      "imageUrl": _vm.markdownImagePreviewUrl || undefined
    },
    on: {
      "close": _vm.onImagePreviewerClose
    }
  }) : _vm._e(), _vm.isNonEmptyObject(_vm.props.bottomQuickOrder) && _vm.props.showBottomQuickOrder ? _c('BottomQuickOrder', {
    staticClass: "bottom-quick-order",
    attrs: {
      "bottomQuickOrder": _vm.props.bottomQuickOrder
    },
    on: {
      "closeOrder": _vm.closeBottomQuickOrder,
      "sendOrder": _vm.sendBottomQuickOrder
    }
  }) : _vm._e()], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }